/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export const LuisKeyCodes = {
    Tab: 'Tab',
    Space: ' ',
    End: 'End',
    Home: 'Home',
    Enter: 'Enter',
    OpenBraces: '{',
    CloseBraces: '}',
    Escape: 'Escape',
    Delete: 'Delete',
    ArrowUp: 'ArrowUp',
    Backspace: 'Backspace',
    ArrowLeft: 'ArrowLeft',
    ArrowDown: 'ArrowDown',
    ArrowRight: 'ArrowRight'
};
